/*
 * @Description: 数据看板 mutations type
 */

export enum AnalysisMutationTypes {
  SET_SCREENFULL = 'SET_SCREENFULL',
  SET_SCREENTHEME = 'SET_SCREENTHEME',
}
